import React from "react";

import { UseFormReturn } from "react-hook-form";

import {
    Box,
    Button,
    Grid,
} from "@mui/material";

import {
    AgeClassification,
    ContentDescription,
    ContentStatus,
    MusicCueSheet
} from "models";

import { Trans } from "@lingui/macro";

import { DetailFormProps, DetailFormState } from "./models";

import { withUseFormHook, } from "@sinossi/mates-react-library";

import * as Yup from "yup";

import { RadioType } from "./radio-type/radio-type";
import { CONTENT_TYPE_FORM_CONSTANT, ContentType, SegregationType } from "commons/form-constants";
import MetadataSection from "./metadata-section/metadata-section";
import { LiveSection } from "./live-section/live-section";
import { VodSection } from "./vod-section/vod-section";
import { Player } from "components/player-page/player/player";
import { SegregationSection } from "./segregation-section/segregation-section";

const DetailFormSchema = Yup.object().shape({
});

class CreateAndEditContentDetailForm extends React.Component<DetailFormProps & UseFormReturn, DetailFormState> {

    constructor(props: any) {

        super(props);

        this.state = {
            isThumbUploaded: false,
            isVideoUploaded: !!this.props.content?.vodAdditionalInfos,
            fileImgName: null,
            fileImg: null,
            fileImgURL: null,
            fileVideoName: null,
            fileVideo: null,
            fileVideoURL: null,
            contentType: "VOD",
            encodingMessage: false,
            musicCueSheet: this.props.musicCueSheetsList,
            tagList: [],
            title: [],
            synopsis: [],
            genre: [],
            festivals: [],
            awards: [],
            contentIssues: [],
            subtitles: [],
            formFlag: false,
            isThumbnailUpdated: false,
	        isVodUpdated: false
        };

    }

    componentDidMount() {
        
        this.setFormContentDefaultValue();

        if (this.props.content !== null) {
            this.setFormDefaultValue();
        }

        this.setState(() => ({ formFlag: true }));
    }

    private setFormContentDefaultValue = () => {
        this.props.setValue("live.hours", "0");
        this.props.setValue("live.minutes", "30");
        this.props.setValue("vod.encoding", process.env.REACT_APP_ENCODING_ENABLED === "true")
    }

    private setFormDefaultValue = () => {

        this.setState(() => ({
            title: this.props.content!.title,
            synopsis: this.props.content!.synopsis,
            musicCueSheet: this.props.musicCueSheetsList,
            fileImgName: this.props.content!.thumbnailData.fileName,
            fileImgURL: this.props.content!.thumbnailServingUrl,
            isThumbUploaded: true,
            subtitles: this.props.content!.subtitles,
            tagList: this.props.content!.tagList,
            genre: this.props.content!.genre,
            festivals: this.props.content!.festivals,
            contentIssues: this.props.content!.contentIssues,
            awards: this.props.content!.awards
        }));


        this.props.setValue("metadata.director", this.props.content!.director.join(","));
        this.props.setValue("metadata.producer", this.props.content!.producer.join(","));
        this.props.setValue("metadata.cast", this.props.content!.cast.join(","));
        this.props.setValue("metadata.writer", this.props.content!.writer.join(","));
        this.props.setValue("metadata.composer", this.props.content!.composer.join(","));
        this.props.setValue("metadata.dop", this.props.content!.dop.join(","));
        this.props.setValue("metadata.editor", this.props.content!.editor.join(","));
        this.props.setValue("metadata.academyQualified", this.props.content!.academyQualified.join(","));
        this.props.setValue("metadata.dialogue", this.props.content!.dialogue);
        this.props.setValue("metadata.music", this.props.content!.music);
        this.props.setValue("metadata.productionYear", this.props.content!.productionYear);
        this.props.setValue("metadata.releaseDate", this.props.content!.releaseDate);
        this.props.setValue("metadata.ageClassification", this.props.content!.ageClassification);
        this.props.setValue("metadata.color", this.props.content!.color);
        this.props.setValue("metadata.type", this.props.content!.type);
        this.props.setValue("metadata.country", this.props.content!.country);
        this.props.setValue("metadata.durationInHours", Math.floor(Number(this.props.content!.durationInSeconds) / 3600));
        this.props.setValue("metadata.durationInMinutes", Math.floor(Number(this.props.content!.durationInSeconds % 3600) / 60));
        this.props.setValue("metadata.durationInSeconds", Math.floor(Number(this.props.content!.durationInSeconds) % 60));

        if(this.props.content!.seriesData){
            this.props.setValue("metadata.serie", "true");
            this.props.setValue("metadata.serieTitle", this.props.content!.seriesData.seriesId);
            this.props.setValue("metadata.season", this.props.content!.seriesData.season);
            this.props.setValue("metadata.episode", this.props.content!.seriesData.episodeNumber);
        } else {
            this.props.setValue("metadata.serie", "false");
        }

        let language = this.props.collectionsList.languageList.list.find(language => language.isoCode === this.props.content!.language);
        this.props.setValue("metadata.language", language?.id);

        this.props.setValue("segregation.segregationType", this.props.content!.segregationType);
        this.props.setValue("segregation.price", this.props.content!.payPerViewSegregationAdditionalInfos?.price);
        this.props.setValue("segregation.currency", this.props.content!.payPerViewSegregationAdditionalInfos?.currency);
    }


    private checkFilmDuration = (seconds: string, minutes: string, hours: string): boolean => {
        const secondsInt = parseInt(seconds, 10);
        const minutesInt = parseInt(minutes, 10);
        const hoursInt = parseInt(hours, 10);

        if (isNaN(secondsInt) || isNaN(minutesInt) || isNaN(hoursInt)) {
            return false;
        }

        if (secondsInt > 59 || minutesInt > 59 || hoursInt < 0) {
            return false;
        }

        if (secondsInt < 0 || minutesInt < 0 || hoursInt < 0) {
            return false;
        }

        if (secondsInt === 0 && minutesInt === 0 && hoursInt === 0) {
            return false;
        }

        return true;

    }

    private submitForm = (values: any) => {

        let duration

        if(!this.checkFilmDuration(values.metadata.durationInSeconds, values.metadata.durationInMinutes, values.metadata.durationInHours)) {
            duration = NaN
        }
        else{
            duration= Number(values.metadata.durationInHours) * 3600 + Number(values.metadata.durationInMinutes) * 60 + Number(values.metadata.durationInSeconds)
        }

        let stepData: any = {
            title: this.state.title,
            synopsis: this.state.synopsis,
            director: values.metadata.director ? values.metadata.director.split(",") : [],
            producer: values.metadata.producer ? values.metadata.producer.split(",") : [],
            cast: values.metadata.cast ? values.metadata.cast.split(",") : [],
            writer: values.metadata.writer ? values.metadata.writer.split(",") : [],
            composer: values.metadata.composer ? values.metadata.composer.split(",") : [],
            dop: values.metadata.dop ? values.metadata.dop.split(",") : [],
            editor: values.metadata.editor ? values.metadata.editor.split(",") : [],
            festivals: this.state.festivals,
            awards: this.state.awards,
            academyQualified: values.metadata.academyQualified ? values.metadata.academyQualified.split(",") : [],
            language: values.metadata.language,
            subtitlesFiles: this.state.subtitles,
            dialogue: values.metadata.dialogue,
            music: values.metadata.music,
            musicCueSheet: this.state.musicCueSheet,
            country: values.metadata.country,
            productionYear: values.metadata.productionYear,
            releaseDate: values.metadata.releaseDate,
            genre: this.state.genre,
            ageClassification: values.metadata.ageClassification === "" ? AgeClassification.ALL : values.metadata.ageClassification,
            contentIssues: this.state.contentIssues,
            color: values.metadata.color,
            type: this.props.content ? this.props.content.type : values.contentType,
            durationInSeconds: duration,
            subtitles: this.state.subtitles,
            tagList: this.state.tagList,
            isThumbnailUpdated: this.state.isThumbnailUpdated,
	        isVodUpdated: this.state.isVodUpdated
        };

        let language = this.props.collectionsList.languageList.list.find(language => language.id === values.metadata.language);
        stepData.language = language?.isoCode;

        if(!this.props.content || this.state.isThumbnailUpdated) {
            stepData.thumbnailFile = this.state.fileImg;
        }

        if(!this.state.isThumbnailUpdated) {
            stepData.thumbnailFile = this.props.content?.thumbnailData;
        }

        if (this.state.isVodUpdated) {
            stepData.needsEncoding = values.vod.encoding;
            stepData.vodFile = this.state.contentType === ContentType.VOD ? this.state.fileVideo : undefined;
            stepData.eventStartDateTime = this.state.contentType === ContentType.LIVE ? values.live.eventStartDateTime : undefined;
            stepData.eventEndDateTime = this.state.contentType === ContentType.LIVE ? this.getEndDate(values.live.eventStartDateTime, values.live.hours, values.live.minutes) : undefined;
        }

        if(values.metadata.serie === "true") {
            stepData.seriesData = {
                seriesId: values.metadata.serieTitle,
                episodeNumber: values.metadata.episode,
                season: values.metadata.season,
            }
        }

        if(this.props.content) {
            stepData.segregationType = values.segregation.segregationType;

            if (values.segregation.segregationType === SegregationType.PAY_PER_VIEW) {
                stepData.payPerViewSegregationAdditionalInfos = {
                    price: values.segregation.price,
                    currency: values.segregation.currency
                };
            }
        }

        this.props.onDetailSubmit(stepData);
    };

    private getEndDate = (eventStartDateTime: string, hours: string, minutes: string) => {
        let endDate: Date = new Date(eventStartDateTime)
        endDate.setMinutes(endDate.getMinutes() + parseInt(minutes))
        endDate.setHours(endDate.getHours() + parseInt(hours))
        return endDate
    }

    private parseFileImg = (event: any) => {

        this.setState(() => ({
            fileImg: event.target.files[0],
            fileImgName: event.target.files[0].name,
            fileImgURL: URL.createObjectURL(event.target.files[0]),
            isThumbUploaded: true,
            isThumbnailUpdated: true
        }));
    };

    private removeFileImg = () => {
        this.setState(() => ({
            fileImg: null,
            fileImgName: null,
            isThumbUploaded: false
        }));
    };

    private parseFileVideo = (event: any) => {

        /*è fatto solo perchè se no il player non mostra n*/
        this.setState(() => ({
            fileVideoURL: null,
        }),() => {
            this.completeParseFileVideo(event);
        });
    };

    private completeParseFileVideo = (event: any) =>{
        this.setState(() => ({
            fileVideo: event.target.files[0],
            fileVideoName: event.target.files[0].name,
            fileVideoURL: URL.createObjectURL(event.target.files[0]),
            isVideoUploaded: true,
            isVodUpdated: true
        }));
    }

    private parseSubtitlesFiles = (event: any) => {

    };


    private updateType = (value: string): void => {
        this.setState(() => ({
            contentType: value,
        }));

    };

    private showEncodingMessage = (): boolean => {

        if (!this.state.encodingMessage) {
            this.setState(() => ({
                encodingMessage: true,
            }))
            return false
        } else {
            this.setState(() => ({
                encodingMessage: false,
            }))
            return false
        }
    };

    private updadateContentTitleAndSynopsis = (titleList: ContentDescription[], synopsisList: ContentDescription[]) => {
        this.setState(() => ({
            title: titleList,
            synopsis: synopsisList
        }))
    }

    private updateMusicSheetData = (newMusicCueSheet: MusicCueSheet[]) => {
        this.setState(() => ({
            musicCueSheet: newMusicCueSheet
        }))
    }


    private updateContentTagList = (list: string[]) => {
        this.setState(() => ({
            tagList: list,
        }))
    }

    private updateContentGenre = (list: string[]) => {
        this.setState(() => ({
            genre: list,
        }))
    }

    private updateContentFestivals = (list: string[]) => {
        this.setState(() => ({
            festivals: list,
        }))
    }

    private updateContentAwards = (list: string[]) => {
        this.setState(() => ({
            awards: list,
        }))
    }

    private updateContentIssues = (list: string[]) => {
        this.setState(() => ({
            contentIssues: list,
        }))
    }

    private updateSubtitles = (subtitles: any): void => {
        this.setState(() => ({
            subtitles: subtitles,
        }), () => console.log(this.state.subtitles));
    };

    private checkIsVisible = (): boolean => {

        const status = this.props.content!.status;
      
        const invisibleStatuses = [
          ContentStatus.PENDING_ENCODING,
          ContentStatus.PENDING_LIVE_RESOURCES_CREATION,
          ContentStatus.PENDING_LIVE_RESOURCES_START,
          ContentStatus.PENDING_THUMB_UPLOAD,
          ContentStatus.PENDING_UPLOAD,
        ];

        if(invisibleStatuses.includes(status)){
            return false
        }
      
        return true;
    }      

    render() {
        return (
            <Box>
                {this.state.formFlag && <form onSubmit={this.props.handleSubmit(this.submitForm)}>
                    <Grid container>

                        {/* **************** CONTENT TYPE CONTAINER **************** */}
                        {this.props.content === null && <Grid item
                            xs={12}
                            p={3}
                            borderRadius="5px"
                            bgcolor={process.env.REACT_APP_THIRD_COLOR}>

                            <RadioType
                                valueList={CONTENT_TYPE_FORM_CONSTANT}
                                name="contentType"
                                updateType={this.updateType}
                                {...this.props} />
                        </Grid>}

                        {/* **************** SETUP LIVE CONTAINER **************** */}
                        {this.props.content === null && <Grid item
                            xs={12}
                            p={3}
                            mt={2}
                            borderRadius="5px"
                            bgcolor={process.env.REACT_APP_THIRD_COLOR}
                            hidden={this.state.contentType !== "LIVE"}>
                            <LiveSection
                                name="live"
                                {...this.props} />
                        </Grid>}

                        {/* **************** PLAYER **************** */}
                        {(this.props.content !== null && !this.state.isVodUpdated) && this.checkIsVisible() && <Grid item xs={12} borderRadius="5px">
                            <Player content={this.props.content}></Player>
                        </Grid>}

                        {/* **************** SETUP VOD CONTAINER **************** */}
                        <Grid item
                            xs={12}
                            p={3}
                            mt={2}
                            borderRadius="5px"
                            className="vod-container"
                            bgcolor={process.env.REACT_APP_THIRD_COLOR}
                            hidden={this.state.contentType !== "VOD"}>
                            <VodSection
                                name="vod"
                                fileVideoName={this.state.fileVideoName}
                                fileVideoURL={this.state.fileVideoURL}
                                encodingMessage={this.state.encodingMessage}
                                parseFileVideo={this.parseFileVideo}
                                showEncodingMessage={this.showEncodingMessage}
                                isVodUpdated={this.state.isVodUpdated}
                                {...this.props} />
                        </Grid>

                        {/* **************** SEGREGATION CONTAINER **************** */}
                        {this.props.content !== null && <Grid item
                            xs={12}
                            p={3}
                            mt={2}
                            borderRadius="5px"
                            bgcolor={process.env.REACT_APP_THIRD_COLOR}
                            hidden={this.state.contentType !== "VOD"}>
                            <SegregationSection
                                name="segregation"
                                {...this.props} />
                        </Grid>}

                        {/* **************** METADATA CONTAINER **************** */}
                        <Grid item
                            xs={12}
                            p={3}
                            mt={2}
                            borderRadius="5px"
                            bgcolor={process.env.REACT_APP_THIRD_COLOR}>
                            <MetadataSection
                                name="metadata"
                                fileImgName={this.state.fileImgName}
                                fileImgURL={this.state.fileImgURL}
                                parseSubtitlesFiles={this.parseSubtitlesFiles}
                                isThumbUploaded={this.state.isThumbUploaded}
                                removeFileImg={this.removeFileImg}
                                parseFileImg={this.parseFileImg}
                                updateContentTagList={this.updateContentTagList}
                                title={this.state.title}
                                synopsis={this.state.synopsis}
                                musicCueSheets={this.state.musicCueSheet}
                                updateTitleAndSynopsis={this.updadateContentTitleAndSynopsis}
                                updateMusicSheetData={this.updateMusicSheetData}
                                updateContentGenre={this.updateContentGenre}
                                updateContentFestivals={this.updateContentFestivals}
                                updateContentAwards={this.updateContentAwards}
                                updateContentIssues={this.updateContentIssues}
                                subtitles={this.state.subtitles}
                                updateSubtitles={this.updateSubtitles}
                                isVideoUploaded={this.state.isVideoUploaded}
                                selectedTags={this.state.tagList}
                                selectedAwards={this.state.awards}
                                selectedFestivals={this.state.festivals}
                                selectedGenres={this.state.genre}
                                selectedIssues={this.state.contentIssues}
                                {...this.props} />
                        </Grid>

                        {/* **************** BUTTON **************** */}
                        <Grid item
                            xs={12}
                            mt={2}
                            textAlign={"right"} >
                            <Button
                                variant="contained"
                                color={"primary"}
                                disabled={this.props.formState.isSubmitting}
                                type="submit">
                                {this.props.content ?
                                    <Trans id="df-submit-edit-button">Modifica</Trans> :
                                    <Trans id="df-submit-create-button">Avanti</Trans>}
                            </Button>
                        </Grid>
                    </Grid>
                </form>}
            </Box>
        );
    }

}

export default withUseFormHook<{}>(CreateAndEditContentDetailForm, DetailFormSchema, {});
